import { render, staticRenderFns } from "./InternationalList.vue?vue&type=template&id=3f3239f5"
import script from "./InternationalList.vue?vue&type=script&lang=js"
export * from "./InternationalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports